import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";

// Home is bundled eagerly so /#section links and scroll restoration work.
// The other pages are separate chunks so their stylesheets only load with
// them: the home design must not pick up Tailwind's preflight reset.
const PrivacyPage = lazy(() => import("./pages/privacy/PrivacyPage"));
const NotFound = lazy(() => import("./pages/not-found/NotFound"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home lang="ar" />} />
          <Route path="/fr" element={<Home lang="fr" />} />
          <Route path="/en" element={<Home lang="en" />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
